module.exports = __webpack_public_path__ + "static/media/Gilroy-Black.4d75798d.woff2";